import { Theme } from '@mui/material';

export const sxScrollWrapper = {
  height: '100%',

  '.simplebar-content': {
    minHeight: '100%',
  },
};

const darkScrollbarStyles = (theme: Theme) => ({
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: theme.palette.grey[800],
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.grey[700],
    borderRadius: '12px',
  },
});

const lightScrollbarStyles = (theme: Theme) => ({
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: theme.palette.grey[200],
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.grey[400],
    borderRadius: '12px',
  },
});

export const sxHorizontalScroll = (theme: Theme) => ({
  minWidth: 0,
  overflowX: 'auto',
  flexWrap: 'nowrap',
  '& > *': { flexShrink: 0 },
  ...lightScrollbarStyles(theme),
});

export const customScrollbar = (theme: Theme) => ({
  '& .customScrollBar': darkScrollbarStyles(theme),
});